import { actionTypes } from '../constants/actionTypes';
import {toastr} from 'react-redux-toastr';
import locationActions from "./locationActions"
import quotationActions from "./quotationActions"

const setCurrentStep = (stepId) => {
    return {
        type: actionTypes.setCurrentStep,
        payload: stepId
    };
};

const setQuotationProvider = (providerId) => {
    return {
        type: actionTypes.setQuotationProvider,
        payload: providerId
    }
};

const setAvailableToGoForward = (valueToSet) => {
    return {
        type: actionTypes.setAvailableToGoForward,
        payload: valueToSet
    };
};

const setAbilityToSwitch = (valueToSet) => {
    return {
        type: actionTypes.setAbilityToSwitch,
        payload: valueToSet
    };
};

const updateIsLead = (payload) => {
    return {
        type: actionTypes.updateIsLead,
        payload: payload
    };
};

const setAvailabilityMessage = (payload) => {
    return {
        type: actionTypes.setAvailabilityMessage,
        payload: payload
    };
};

const setMobileStepPhoneNumbersToSaveData = (payload) => {
    return {
        type: actionTypes.setMobileStepPhoneNumbersToSaveData,
        payload: payload
    };
};

const setMobileStepIsSavingPhoneNumbers = (payload) => {
    return {
        type: actionTypes.setMobileStepIsSavingPhoneNumbers,
        payload: payload
    };
};

const setStep = (payload) => {
    return async (dispatch, getState) => {
        const state = getState()

        let {mobileStepPhoneNumbersToSaveData} = state.steps
        const {abilityToSwitch, mobileStepIsSavingPhoneNumbers, availableSteps, currentStepId, availabilityMessage} = state.steps;
        const movingForward = availableSteps.findIndex(x => x.id === payload) > availableSteps.findIndex(x => x.id === currentStepId);

        if (!mobileStepPhoneNumbersToSaveData) {
            mobileStepPhoneNumbersToSaveData = {
                telephoneNumbers: state.quotation.currentQuotation.telephone_numbers
            }
        }

        if (mobileStepIsSavingPhoneNumbers) {
            return
        }

        if (payload === currentStepId) {
            return
        }

        if (!abilityToSwitch) {
            toastr.error(availabilityMessage);
            return
        }

        dispatch(locationActions.resetSelectedLocationToGlobal())

        if (!movingForward) {
            dispatch(setAvailableToGoForward(true));
        }

        if (currentStepId === 10 && payload !== 10) {
            dispatch(setMobileStepIsSavingPhoneNumbers(true))
            dispatch(quotationActions.saveAKBTelephoneNumbers(
                mobileStepPhoneNumbersToSaveData, 
                state.quotation.currentQuotation.id,
                () => {
                    dispatch(setCurrentStep(payload))
                }
            ))
            return
        }

        dispatch(setCurrentStep(payload))
    }
}

export default {
    setCurrentStep,
    setAvailableToGoForward,
    setQuotationProvider,
    updateIsLead,
    setAvailabilityMessage,
    setAbilityToSwitch,
    setMobileStepPhoneNumbersToSaveData,
    setMobileStepIsSavingPhoneNumbers,
    setStep
}
